import * as React from "react";
import type { SVGProps } from "react";
const Motel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.2 3.1992c.6638 0 1.2.5363 1.2 1.2v9.6h8.4v-6c0-.6637.5363-1.2 1.2-1.2h8.4c1.9875 0 3.6 1.6125 3.6 3.6v8.4c0 .6638-.5362 1.2-1.2 1.2s-1.2-.5362-1.2-1.2v-1.2H2.4v1.2c0 .6638-.5362 1.2-1.2 1.2s-1.2-.5362-1.2-1.2v-14.4c0-.6637.5363-1.2 1.2-1.2m5.4 3.6a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
    />
  </svg>
);
export default Motel;
